import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const useScrollToTop = () => {
  const { pathname } = useLocation()
  const firstSegment = pathname.split('/')[1]

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [firstSegment])
}

export default useScrollToTop
